import React from 'react';

import {CardTitle} from '~src/spacesPlatform/components/card/CardTitle';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { ContentCard } from '~src/spacesPlatform/components/card/ContentCard';
import { ConnectionDisplay } from '~src/spacesPlatform/components/ListView/DataConnectionComponents';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { ContentTooltipProps } from '~src/spacesPlatform/components/tooltip/TooltipHelper';

import { getDatasourceContentUrl } from '../../../../components/cards/DatasourceCard';
import { DataSources } from '../../../../resources/Datasources';
import { IDataConnectionInfo } from '../../../models/IDataConnectionInfo';
import { DataconnectionThumbnail } from './DataconnectionThumbnail';

export class DataconnectionCard extends ContentCard {

  protected getPopoverComponent(): React.ComponentType<ContentTooltipProps> {
    throw 'Popover not supported';
  }

  public render() {
    const {
      content, urls, inWorkbookDatasourcesSubspace, inDatasourceConnectionsSubspace, hovered, selected
    } = this.props;
    const dataconnection = content as IDataConnectionInfo;
    const metadata = ConnectionDisplay.getDisplayMetadata(dataconnection, urls);
    const contentUrl = getDataConnectionContentUrl(
        urls,
        dataconnection,
        inWorkbookDatasourcesSubspace,
        inDatasourceConnectionsSubspace);
    const translatedName = ConnectionDisplay.translatedText(metadata);

    return (
      <div className={CardViewStyles.Card}>
        <DataconnectionThumbnail
          dataconnection={dataconnection}
          metadata={metadata}
          datasourceContentUrl={contentUrl}
          hovered={hovered}
          selected={selected}
          urls={urls}
          aria-label={translatedName.connectionName}
          cardZoomPercentage={this.state.cardZoomPercentage}
        />
        <div className={CardViewStyles.ActionRow} style={this.getCardZoomStyleForActionRow()}>
          { translatedName.nameUnavailable
            ? <CardTitle name={translatedName.connectionName} missingStyle={true} />
            : <CardTitle name={translatedName.connectionName} />
          }
          { this.renderActionsMenu() }
        </div>
      </div>
    );
  }
}

function getDataConnectionContentUrl(
    urls: SpacesSiteUrls,
    dataconnection: IDataConnectionInfo,
    inWorkbookDatasourcesSubspace: boolean,
    inDatasourceConnectionsSubspace: boolean,
): string {

  // If we're already in a data source place, the card href link to where we already are, so
  // don't make it a link.
  if (inDatasourceConnectionsSubspace) {
    return undefined;
  }

  // Otherwise, the connection links to wherever the data source is.
  const datasourceInfo = DataSources.getDatasourceInfoFromDataConnection(dataconnection);
  return getDatasourceContentUrl(urls, datasourceInfo, inWorkbookDatasourcesSubspace);
}
